import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import GuideCardImage from '@hotjar/shared-assets/images/guide-card.png';

export const BannerImage = styled.div<{ src?: string }>`
  width: 100%;
  height: 100%;
  background-image: url('${({ src }) => src || GuideCardImage}');
  background-color: ${tokens.BRAND_COLORS.noon_100};
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
`;
